import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
@Component({
  selector: 'app-image-configuration',
  templateUrl: './image-configuration.component.html',
  styleUrls: ['./image-configuration.component.scss']
})
export class ImageConfigurationComponent implements OnInit {
  image_listing;
  getEngagement;
  multiselect: boolean = true;
  search_image_name = "";
  engagementType = "";
  image_name = "";
  engagement_type = "";
  base64textString;
  Image_Size;
  image_S;
  image_error:boolean = false
  constructor(
    private modalService: NgbModal,
    private apiConfinguration: ApiConfiguration,
    private apiService: ApiService,
    private toast: ToastClientService,
  ) { }

  ngOnInit() {
    this.getImageListing();
    this.getEngagement = [
      { id: 1, type: "Tactical Challenges" },
      { id: 2, type: "Content" },
    ]
  }
  showRegionModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }
  AddData(targetModal) {
    this.showRegionModal(targetModal);
  }
  uploadXlsx(evt) {
    this.image_error = false;
    this.image_S = (evt[0].size / 1024).toFixed(2);
    this.Image_Size = Math.floor(this.image_S)
    console.log(this.Image_Size);
    if (this.Image_Size > 500) {
      this.image_error = true;
    } else {
      var files = evt;
      var file = files[0];
      if (files && file) {
        var reader = new FileReader();
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsBinaryString(file);
      }
    }

  }
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64textString = "data:image/jpeg;base64," + btoa(binaryString);
  }
  

  getImageListing() {
    this.apiService.get(this.apiConfinguration.image_listing + "?image_name=" + this.search_image_name + "&engagement_type=" + this.engagementType).
      subscribe((res: any) => {
        console.log("ImageList", res);
        this.image_listing = res.data;
      })
  }
  selectedItem(engagement) {
    this.engagementType = engagement[0].id
    console.log("engagemet", this.engagementType);
  }
  filterListOfRecords() {
    console.log(this.search_image_name);
    this.getImageListing();
  }
  submitModalData() {
    if (this.image_name == "" || this.engagement_type == "" || this.base64textString == undefined) {
      this.toast.Error("Fields are required")
    }

    else {
      let payload = {

        image_url: this.base64textString,
        engagement_type: this.engagement_type,
        image_name: this.image_name,
      }
      console.log(payload);
      this.apiService.post(this.apiConfinguration.Add_image, payload)
        .subscribe((data: any) => {
          console.log("postData", data)
          this.toast.Success("Success");
          this.modalService.dismissAll();
          this.getImageListing()
        }, (err) => {
          console.log(err.message)
        })

    }
  }
validation(){

}
omit_special_char(event)
  {   
     var k;  
     k = event.charCode; 
     return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); 
  }

}
